import { SVGProps } from 'react';

/** Rounded play triangle for the sidebar's Actions row. */
export const ActionsIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg data-icon xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18 18" fill="none" aria-hidden {...props}>
    <path
      d="M4 3.25 L4 14.75 Q4 15.5 4.665 15.154 L15.835 9.346 Q16.5 9 15.835 8.654 L4.665 2.846 Q4 2.5 4 3.25 Z"
      stroke="currentColor"
      strokeWidth={1.25}
      strokeLinejoin="round"
    />
  </svg>
);
